<template>
  <!-- 页面导航栏 -->
  <div :class="className?className:'header_breadcrumb'">
    <el-breadcrumb separator="/">
      <template v-for="item in datas">
        <template v-if="item == '首页'">
          <el-breadcrumb-item style="color: #3c4858 !important;">
            <img src="/static/img/table/navigate.png" border="0" align="absmiddle" width="15" style="vertical-align:bottom"/>
            {{item}}
          </el-breadcrumb-item>
        </template>
        <template v-if="item != '首页'">
          <el-breadcrumb-item style="color: #3c4858 !important;">{{item}}</el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: "PageHeader",
    props: {
      className :{
        type:String,
        default:'header_breadcrumb'
      }
    },
    watch: {
    },
    data() {
      return {
        datas: ""
      }
    },
    methods: {
      initLoad: function () {
        let params = {"menuPath": this.$route.path};
        this.$api.home.getPageLevel(params).then((res) => {
          if (res.code === 200) {
            this.datas = res.data;
          }
        });
      }
    },
    mounted() {
      this.initLoad();
    }
  }
</script>

<style scoped lang="scss">
  .header_breadcrumb {
    text-align: left;
    font-size: 13px;
    color: #3c4858 !important;
    /*margin-left: 20px;*/
    margin-top: 8px;
    height: 15px;
  }

  .header_breadcrumb_left {
    text-align: left;
    font-size: 13px;
    color: #3c4858 !important;
    margin-left: 20px;
    margin-top: 8px;
    height: 15px;
  }

  .el-breadcrumb__item,.el-breadcrumb__inner{
    font-size: 13px;
    color: #3c4858 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Biz/Common/PageHeader.vue